export default __webpack_public_path__ + "static/media/money-back.326fa5aa.svg";